module.exports = __webpack_public_path__ + "static/Chat_app_screen-bbbcee67429c18ea2ab4e3174e14535c.png";